import { getSharedConfig } from "../../createSharedConfig"
import { RACK_COLORS } from "@/js/pages/product/rackbuilder/constants"
import { RackOptions } from "@/js/pages/product/rackbuilder/RackTypes"
import { findBundleProduct, getAccessoryQuantity } from "@/js/pages/product/rackbuilder/utils/product-lookup"
import { getFxtEdition } from "@/js/pages/product/rackbuilder/utils/fxt-utils"
import { getCommonAccessorySelections } from "@/js/pages/product/rackbuilder/utils/selection-utils"
import { IRogue, BuyRequest } from "@/js/services/RogueTypes"
import { getSimpleForBuyRequest } from "@/js/helpers/buy-request"

export function createHRAddonConfig(rogue: IRogue, buyRequest: BuyRequest): RackOptions {
  const ft = getSimpleForBuyRequest(buyRequest, rogue)
  const edition = ft?.attributes?.edition?.toString().toLowerCase() || ''

  const sharedConfig = getSharedConfig(rogue, buyRequest)
  const height = (ft?.attributes.rack_height as string)?.replace('"', '') as RackOptions['height'] || '90'
  const { trolleySelection, lowRowSelection, latBarSelection } = getCommonAccessorySelections(rogue, buyRequest, sharedConfig.materials || {})

  return {
    ...sharedConfig,
    back            : '',
    front           : 'crossmember top 4',
    edition         : getFxtEdition(edition),
    color           : RACK_COLORS['Rogue Red'],
    jcup            : '',
    height,
    depth           : '2',
    sixPost         : false,
    storagePosts    : false,
    ghostRack       : false,
    ftShrouds       : ft?.attributes?.rig_or_wm !== 'No',
    spotterArms     : getAccessoryQuantity(rogue, buyRequest, 'safety spotter'),
    frontStabilizer : Boolean(findBundleProduct(rogue, buyRequest, 'half rack feet', true)),
    trolleySelection,
    latBarSelection,
    lowRowSelection,
    isAddon         : true,
  }
}
